import React, { useState } from 'react'
import styled from 'styled-components'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
// import bannerL from '../../images/registration/bannerL.png'
// import bannerP from '../../images/registration/bannerP.png'
// import logo from '../../images/event-logo.png'
import { COLORS, SIZES } from '../../styles/theme'
import Axios from 'axios'
import config from '../../config'
import { toast } from 'react-toastify'
import routes from '../../routes'

const Page = styled.div`
  min-height: 100vh;
  background-image: url(${config.assets.entrance.landscape});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 0;
  padding-bottom: 2em;
  padding-top: 2em;
  color: #000000;
  text-align: center;
  text-transform: uppercase;

  .mobile-show {
    display: none;
  }
  .brand {
    width: 80%;
    height: 100%;
    padding-bottom: 3em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .row {
    select.form-input {
      text-align-last: center;
    }
   
    h6.subtitle {
      font-weight: 500;
      margin: 24px 0;
    }
    .error-message {
      font-weight: 500;
      color: #C10244;
    }
   
    .register-form {
      padding: 2.5em 0;

      .form-group {
        width: 100%;
        margin: 8px auto;
        box-shadow: 0 5px 4px -4px #000000;
        background: #FFFFFF;
        border: none;
        border-radius: 25px;
        font-weight: 600;
        text-align: center;
        padding-right: 16px;
        label {
          color: #000000;
          padding: 0 8px;
          margin: 0 auto;
          padding-right: 0;
          font-size: 13px;
        }
        .required:before {
          content:"* ";
          color: red;
        }
        input[type='tel'],
        .form-input {
          display: block;
          color: #484848;
          width: 100%;
          font-weight: 500;
          background: transparent;
          border: none;
          padding: 4px 24px;
          outline: none;
          text-align: center;
        }
      }
      #password {
        width: 12px;
        margin: 2px 4px;
      }
    }
  }
  ${SIZES.mobile} {
    background-image: url(${config.assets.entrance.portrait});
    padding: 0;
    padding-bottom: 2.5em;
    padding-top: 1em;
    font-size: 0.9em;
    .mobile-show {
      display: block;
    }
    .mobile-hide {
      display: none;
    }
    .col-md-6 {
      flex: none;
      max-width: 100%
    }
    .subtitle, .error-message {
      padding: 0 20px;
      font-size: 12px;
      font-weight: 600;
    }
  }
  
  
  button.submit-btn {
    background: #C10244;
    box-shadow: 0 5px 4px -4px #000000;
    width: 40%;
    color: #FFFFFF;
    font-weight: 500;
    border: none;
    border-radius: 56px;
    display: flex;
    justify-content: center;
    padding: 12px 24px;
    margin: 16px auto;
    margin-bottom: 0;
    font-size: 1em;
    outline: none;

    ${SIZES.mobile} {
      width: 60%;
      padding: 10px 24px;
    }

    &:disabled {
      cursor: not-allowed;
      background: grey;
      border: solid 1px ${COLORS.primary};
    }

    div {
      line-height: 32px;
    }
  }
`

export default function RegisterFormPage() {
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [fullName, setFullName] = useState('')
  const [department, setDepartment] = useState('')
  const [others, setOthers] = useState('')
  const [line, setLine] = useState("")
  const [otherLine, setOtherLine] = useState("")
  const [position, setPosition] = useState('')
  const [reportingManager, setReportingManager] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const optionList = [
    'Finance',
    'HR',
    'SFE',
    'Marketing',
    'Sales',
    'Management',
    'IT',
    'Others',
  ]
  const lineList = [
    'CV',
    'BMW',
    'RD',
    'SP',
    'CVBMW',
    'RDSP',
    'COMBI',
    'Others',
  ]

  const handleEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }
  const handleOther = (e) => {
    if (e.target.name === 'department') {
      setDepartment(e.target.value)
      setOthers("")
    }
    if (e.target.name === 'line') {
      setLine(e.target.value)
      setOtherLine("")
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    let finalDepartment = department
    let finalLine = line
    if (department === 'Others') {
      finalDepartment = others.trim()
    }
    if (line === 'Others') {
      finalLine = otherLine.trim()
    }
    const options = {
      full_name: fullName.trim(),
      department: finalDepartment,
      line: finalLine,
      reporting_manager: reportingManager.trim(),
      position: position.trim(),
      email,
      password: password.trim(),
    }
    Axios.post(`${config.apiUrl}/api/v1/register`, options)
      .then(() => {
        setLoading(false)
        history.push(routes.postRegister)
      })
      .catch((err) => {
        setLoading(false)
        toast(err.response.data.message)
      })
  }

  const hasEmptyField = !(
    fullName.length &&
    department.length &&
    ((department === 'Others') == (others.length > 0)) &&
    line.length &&
    ((line === 'Others') == (otherLine.length > 0)) &&
    position.length &&
    reportingManager.length &&
    email.length &&
    password.length >= 8 
  )

  return (
    <Page>
      <div className="mobile-show mt-5 mb-3">
        {/* <img width="100%" src={bannerP} alt="event-banner" /> */}
      </div>
      <Row id="main" noGutters className="px-4 pl-md-0 pt-2 pb-3">

        <Col md={6} className="mobile-hide">
          <div className="brand">
            {/* <img width="100%" src={bannerL} alt="event-banner" className="d-block ml-0 mr-auto" /> */}
            {/* <img width="60%" src={logo} alt="event-logo" className="d-block mr-0 ml-auto" /> */}
          </div>
        </Col>

        <Col md={6} className="px-md-4">
          <h6 className="subtitle">Kindly fill in your details below to complete registration</h6>
          {hasEmptyField && (
            <p className="error-message m-0">
              * Please fill in the required field to proceed.
            </p>
          )}
          <Row className="register-form py-3" noGutters>
            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">Full Name</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col sm={6} className="pr-md-4">
              <Form.Group>
                <label className="required">Department</label>
                <select
                  className="form-input"
                  value={department}
                  name="department"
                  onChange={handleOther}
                >
                  <option value="" disabled selected hidden>-- SELECT --</option>
                  {optionList.map((item, i) => (
                    <option key={`option-${i}`} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Form.Group>
            </Col>
            
            <Col sm={6} className="pr-md-4">
              <Form.Group>
                <label>Others, please specify</label>
                <input
                  className="form-input"
                  type="text"
                  value={others}
                  placeholder={department !== 'Others' ? "Not Applicable" : "* Please specify here"}
                  disabled={department !== 'Others'}
                  onChange={(e) => setOthers(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col sm={6} className="pr-md-4">
              <Form.Group>
                <label className="required">Line</label>
                <select
                  className="form-input"
                  value={line}
                  name="line"
                  onChange={handleOther}
                >
                  <option value="" disabled selected hidden>-- SELECT --</option>
                  {lineList.map((item, i) => (
                    <option key={`line-${i}`} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Form.Group>
            </Col>
            <Col sm={6} className="pr-md-4">
              <Form.Group>
                <label>Others, please specify</label>
                <input
                  className="form-input"
                  type="text"
                  value={otherLine}
                  placeholder={line !== 'Others' ? "Not Applicable" : "* Please specify here"}
                  disabled={line !== 'Others'}
                  onChange={(e) => setOtherLine(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">Position</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">Reporting Manager</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={reportingManager}
                  onChange={(e) => setReportingManager(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">Email</label>
                <input
                  className="form-input"
                  required
                  type="email"
                  value={email}
                  onChange={handleEmailInput}
                />
              </Form.Group>
            </Col>
            
            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">
                  Password (min 8 characters)
                </label>
                <input
                  className="form-input"
                  required
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
            </Col>
            
            <div className="w-100 pr-md-4">
              <Button
                type="submit"
                className="submit-btn"
                variant="default"
                disabled={hasEmptyField || loading}
                onClick={handleSubmit}
              >
                <div>{loading ? 'Loading...' : 'SUBMIT'}</div>
                {/* <div className="arrow">⇀</div> */}
              </Button>
            </div>
          </Row>
        </Col>
      </Row>
      <div className="mobile-show">
        {/* <img width="40%" src={logo} alt="event-logo" className="d-block mx-auto" /> */}
      </div>
    </Page>
  )
}
